<template>
  <!--
    Vuetify 2 VIcon only uses $slots.default[0].text — keep {{ resolved }} as the
    sole slot node (no surrounding whitespace) or custom classes like "accept" are lost.
    Forward parent listeners as-is (do not invent click/mousedown). VIcon renders
    <button> when a click listener is present; fabricating one breaks i.accept e2e
    and nested buttons. Passing all listeners keeps tooltip mouseenter/mouseleave etc.
  -->
  <v-icon v-bind="$attrs" v-on="iconListeners">{{ resolved }}</v-icon>
</template>

<script lang="ts">
export default {
  name: "BmIcon",
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { computed, getCurrentInstance } from "vue";
import type { BmIconName, IconTheming } from "@/components/controls/bmIconMap";
import { resolveIcon } from "@/components/controls/bmIconMap";

interface Props {
  icon: BmIconName;
  theming?: IconTheming;
}

const props = withDefaults(defineProps<Props>(), {
  theming: "Themed",
});

const instance = getCurrentInstance();

// Vue 2: parent listeners live on $listeners (not $attrs). Avoid template $listeners
// (eslint vue/no-deprecated-dollar-listeners-api) while still forwarding everything.
const iconListeners = computed(
  () => (instance?.proxy?.$listeners ?? {}) as Record<string, Function>
);

const resolved = computed(() => resolveIcon(props.icon, props.theming));
</script>
